import API from "serviceshift-ui/api-client";

export default {
  fetchAccessRole({ commit, state }) {
    if (state.accessRole) {
      return Promise.resolve(state.accessRole);
    }

    if (state.accessRoleLoading) {
      return new Promise((resolve) => {
        const unsubscribe = this.subscribe((mutation) => {
          if (
            mutation.type === "replace" &&
            mutation.payload.state === "accessRole"
          ) {
            unsubscribe();
            resolve(state.accessRole);
          } else if (
            mutation.type === "replace" &&
            mutation.payload.state === "accessRoleError"
          ) {
            unsubscribe();
            reject(state.accessRoleError);
          }
        });
      });
    }

    commit("replace", { state: "accessRoleLoading", data: true });

    return API.makeRequest("/admin/v4/access_role", {
      method: "GET",
      headers: {
        skipRedirectOn401: true
      }
    })
      .then((res) => {
        commit("replace", {
          state: "accessRole",
          data: res.data.data
        });
        return res.data.data;
      })
      .catch((error) => {
        commit("replace", { state: "accessRoleError", data: error });
        throw error;
      })
      .finally(() => {
        commit("replace", { state: "accessRoleLoading", data: false });
      });
  }
};
